// The built-in library: the exercise catalog (packages/core/src/catalog) and the default workouts (./workouts).
// The 20 starter exercises and the 2 starter workouts keep their ids; everything else was added on 2026-10-13.
import { CATALOG } from './catalog';
import type { Exercise, Workout } from './types';
import { DEFAULT_WORKOUTS } from './workouts';

export const EXERCISES: Exercise[] = CATALOG;
export const WORKOUTS: Workout[] = DEFAULT_WORKOUTS;
